import { KeyboardEvent } from 'react'

/**
 * Regular expression to validate email addresses.
 * Allows alphabets (both cases), numbers, and symbols like `@`, `.`, `_`, `-`.
 */
const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

/**
 * Regular expression to validate names containing only alphabets.
 */
const namePattern = /^[a-zA-Z]+$/
const blockInvalidChar = (e: KeyboardEvent<HTMLInputElement>) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
const phoneNumberPattern = /^(?:\+\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/

/**
 * Regular expression to validate passwords.
 * Requires at least one lowercase letter, one uppercase letter, one digit, one special character,
 * and a total length between 8 and 99 characters.
 */
const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,99}$/

/**
 * Regular expression to validate input without special characters.
 * Allows only alphabets, numbers, and spaces.
 */
const specialCharacterRegex = /^[a-zA-Z0-9 ]+$/

/**
 * Regular expression to validate email special characters.
 * Allows alphabets, numbers, dot (`.`), at (`@`), hyphen (`-`), and underscore (`_`).
 */
const emailSpclChrRegex = /^[a-zA-Z0-9.@\-_]+$/

/**
 * Regular expression to validate numeric input.
 * Allows numbers, spaces, plus (`+`), and minus (`-`) signs.
 */
const isNumberRegex = /^[ 0-9+-]*$/

/**
 * Regular expression to validate alphabets with spaces.
 * Only allows alphabets and spaces.
 */
const alphaWithSpaceRegex = /^[a-zA-Z ]+$/

/**
 * Regular expression to validate alphabets, spaces, numbers, period (`.`), and hyphen (`-`).
 */
const alphaWithSpaceandNumberRegex = /^[a-zA-Z0-9 .-]+$/

export {
    emailRegex,
    blockInvalidChar,
    phoneNumberPattern,
    passwordPattern,
    namePattern,
    specialCharacterRegex,
    emailSpclChrRegex,
    isNumberRegex,
    alphaWithSpaceRegex,
    alphaWithSpaceandNumberRegex
}
